import { createRoot } from "react-dom/client";

const roots = new Map();

export const renderComponent = (element, container) => {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(element);
  return root;
};

export const unmountComponent = (container) => {
  const root = roots.get(container);
  if (root) {
    root.unmount();
    roots.delete(container);
  }
};
